import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import * as menu from '../../config/menu.json';
import Session from '../../utils/session.service';
import ProfileServices from '../../services/profile.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'profile',
	templateUrl: './profile.component.html',
	imports: [ CommonModule, FormsModule, RouterLink ]
})
export default class ProfileView implements OnInit {
	private session: Session = inject(Session);
	private profileServices: ProfileServices = inject(ProfileServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('profile').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.updateUserData();
		this.vm.editProfile = this.editProfile;
		this.vm.logout = this.logout;
		
		this.constructLinks();
	}
	
	constructLinks() {
		var menuType: any = 'DEFAULT';
		if (this.vm.user.origin == 'siffi.com') {
			menuType = 'DEFAULT_SIFFI';
		}
		if (this.vm.user.previsitUser == true) {
			menuType = 'DEFAULT_PREVISIT';
		}
		if (this.vm.user.businessUser && this.vm.user.businessUserType) menuType = this.vm.user.businessUserType;
		var links: any = this.angularHelperService.copy(menu[menuType].dropdownItems || []);
		links.forEach((item) => {
			if (item.label) item.label = this.angularFilterHelperService.translate(item.label);
			if (item.onClick) item.onClick = this.vm[item.onClick];
		});
		this.vm.items = this.angularFilterHelperService.filter(links, { isHiddenInMobile: false });
	}
	
	updateUserData = () => {
		this.vm.user = this.session.getSession().user;
		this.vm.locale = this.vm.user.deviceLanguage;
	}
	
	editProfile = (event) => {
		if (event.preventDefault) event.preventDefault();
		this.updateUserData();
		this.profileServices.openProfileModal(this.vm.user, event, 
			(newProfile) => {
				this.vm.user = newProfile;
				this.session.updateSession();
			}, 
			() => {}
		);
	}
	
	logout = (e) => {
		if (e.preventDefault) e.preventDefault();
		this.session.logoutWithConfirmation(e);
	}
	
}